import { useCallback, useEffect, useState } from 'react';
import { useLlcApi } from '../Api';
import { BusinessSummaryDto } from '../types/businessSummary';

interface CompletedBusinessesState {
  businesses: BusinessSummaryDto[];
  loading: boolean;
  error: boolean;
}

export function useCompletedBusinesses(): CompletedBusinessesState {
  const llcApi = useLlcApi();
  const [state, setState] = useState<CompletedBusinessesState>({
    businesses: [],
    loading: true,
    error: false,
  });

  const load = useCallback(
    async (signal: AbortSignal) => {
      setState((s) => ({ ...s, loading: true, error: false }));
      try {
        const response = await llcApi.get<BusinessSummaryDto[]>(
          '/api/BusinessEntity/completed-user-businesses',
          { signal }
        );
        setState({
          businesses: response.data ?? [],
          loading: false,
          error: false,
        });
      } catch {
        if (signal.aborted) return;
        setState({ businesses: [], loading: false, error: true });
      }
    },
    [llcApi]
  );

  useEffect(() => {
    const controller = new AbortController();
    load(controller.signal);
    return () => controller.abort();
  }, [load]);

  return state;
}
